import {  HttpBackend, HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app-environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WizklubService {
  wizBaseUrl =environment.wizKlubBase
  wizClientToken = environment.wizclienttooken
  errorMessage: any;
  
  constructor(
    private http: HttpClient,private httpBackend:HttpBackend) { 
    
    }


  generateWizKlubToken(body, headers){
    return fetch(`${this.wizBaseUrl}/cognito/authorize/security-token/`,{
      method:'POST',
      body: JSON.stringify(body),
      headers
    })
}

ngOnDestroy(){
  
}

}
